import React, { useState } from "react";
import { Input, Button, Card, Space, Typography } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";

import { login, selectUser } from "../../store/slices/authSlice";

const { Title, Text } = Typography;

const Login = () => {
  const user = useSelector(selectUser);

  const [confirmLoading, setConfirmLoading] = useState(false);
  const dispatch = useDispatch();
  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string().email().required("Email is required!"),
    password: Yup.string().required("Password is required!"),
  });

  const onSubmit = (values, actions) => {
    setConfirmLoading(true);
    dispatch(
      login(values, () => {
        setConfirmLoading(false);
        actions.setSubmitting(false);
      })
    );
  };

  if (user) {
    return <Redirect to="/home" />;
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Card style={{ width: 300 }}>
        <h2 style={{ textAlign: "center" }}>Login</h2>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({
            errors,
            touched,
            handleChange,
            handleBlur,
            values,
            isSubmitting,
          }) => (
            <Form name="login-form">
              <Space direction="vertical" style={{ width: "100%" }} size={20}>
                <div>
                  <Title level={5}>Email *</Title>
                  <Input
                    name="email"
                    prefix={<UserOutlined />}
                    placeholder="Email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.email && touched.email ? (
                    <Text type="danger">{errors.email}</Text>
                  ) : null}
                </div>
                <div>
                  <Title level={5}>Password *</Title>
                  <Input.Password
                    name="password"
                    prefix={<LockOutlined />}
                    placeholder="Password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.password && touched.password ? (
                    <Text type="danger">{errors.password}</Text>
                  ) : null}
                </div>
                <div>
                  <Button
                    loading={confirmLoading}
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%" }}
                    disabled={isSubmitting}
                  >
                    Log in
                  </Button>
                </div>
              </Space>
            </Form>
          )}
        </Formik>
      </Card>
    </div>
  );
};

export default Login;
